import {
  afterNextRender,
  Component,
  computed,
  ElementRef,
  input,
  signal,
  viewChild,
} from '@angular/core';

@Component({
  selector: 'app-responsive-value',
  templateUrl: './responsive-value.html',
  host: {
    class: 'block w-full',
    style: 'container-type: inline-size',
  },
})
export class ResponsiveValue {
  value = input.required<string>();

  private readonly unitEl = viewChild<ElementRef>('unitEl');
  protected unitWidth = signal(0);

  protected fontSize = computed(() => {
    const len = this.value().length;
    const unit = this.unitWidth();

    if (len === 0) return '2.25rem';

    // Numerals are ~0.55em wide on average. The +0.5 accounts for the &nbsp; separator.
    const charFactor = (len + 0.5) * 0.55;

    // Use CSS container query width units (cqw) so the browser resolves
    // the container width natively — no ResizeObserver needed.
    if (unit > 0) {
      return `clamp(1.25rem, calc((100cqw - ${unit}px) / ${charFactor}), 2.25rem)`;
    }

    return `clamp(1.25rem, calc(100cqw / ${charFactor}), 2.25rem)`;
  });

  constructor() {
    afterNextRender(() => {
      const unitNative = this.unitEl()?.nativeElement;
      if (unitNative) {
        this.unitWidth.set(unitNative.getBoundingClientRect().width);
      }
    });
  }
}
